<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript: window.history.go(-1)">返回</a>
        <h1>{{getPushDetailInfo.pustType==1 ? '系统通知' : '消息通知'}}</h1>
        <span class="pull-right icon-right" @click="showDeleteAlert()">删除</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page bg-white" style="min-height:600px">

      <div class="padding-15">
      <div>{{getPushDetailInfo.pushContent}}</div>
      </div>
      <div class="margin-15 padding-15 text-center" v-if='getPushDetailInfo.contentType == 21 && getPushDetailInfo.isAgree == 0'>
        <span class="button-pill-circle" @click="agreeTeacherAddCurcheMsg()">同意</span>
      </div>
      <div class="text-center" v-if='getPushDetailInfo.isAgree == 1'>
          <p class="padding-15">已同意加为老师</p>
      </div>
      <div class="liner margin-15"></div>
      <div class="gray margin-x-15 text-right font-14">{{getPushDetailInfo.pushDateString}}</div>
    </div>
    <div class="maskdiv" v-bind:class="{'hide': showAlert}">
      <div class="popover">
        <div class="pop-wrap text-center">
          <p class="padding-15">您确定要删除本条消息吗？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
            <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deletePushMsg()">删除</a></div>
            <div class="col-xs-6 blue"><a class="blue" @click.prevent="hideDeleteAlert()">不删除</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_push_list_para: service.setPara('getPushList'),
      update_push_para: service.setPara('updatePush'),
      delete_push_para: service.setPara('deletePush'),
      get_broadcast_list_para: service.setPara('getBroadCastList'),
      update_broadcast_para: service.setPara('updateBroadCast'),
      delete_broadcast_para: service.setPara('deleteBroadCast'),
      agree_Teacher_Add_Curche_para: service.setPara('agreeTeacherAddCurche'),
      get_Push_Detail_para: service.setPara('getPushDetail'),
      pushId: 0,
      getPushInfo: [],
      getBroadcastInfo: [],
      getPushDetailInfo: {},
      detailInfo: {},
      pushIdArray: [],
      broadCastArray: [],
      showAlert: true,
      teacherId: 0,
      curcheId: 0
    }
  },
  mounted: function () {
    this.pushId = this.$route.params.pushId
    // this.getPushListMsg()
    // 这是获得广播消息
    // this.getBroadCastMsg()
    this.teacherId = this.cookie_login_data.teacherId
    this.curcheId = this.cookie_login_data.curcheId
    this.getPushDetailMsg()
  },
  methods: {
    getPushListMsg: function () {
      this.get_push_list_para.curcheId = this.curcheId
      this.get_push_list_para.userId = this.teacherId

      let that = this
      let obj = {context: this, para: this.get_push_list_para, successFun: (response) => {
        that.getPushInfo = response.data
        for (var i = 0; i < that.getPushInfo.length; i++) {
          if (that.getPushInfo[i].pushId == that.pushId) {
            that.detailInfo = that.getPushInfo[i]
            if (that.detailInfo.isRead == 0) {
              that.updatePushMsg()
            }
          }
        }
      }}
      service.request(obj)
    },
    getPushDetailMsg: function () {
      this.get_Push_Detail_para.curcheId = this.curcheId
      this.get_Push_Detail_para.teacherId = this.teacherId
      this.get_Push_Detail_para.pushId = this.pushId

      let that = this
      let obj = {context: this, para: this.get_Push_Detail_para, successFun: (response) => {
        that.getPushDetailInfo = response.data
        if (that.getPushDetailInfo.isRead == 0) {
          that.updatePushMsg()
        }
      }}
      service.request(obj)
    },
    updatePushMsg: function () {
      this.pushIdArray.push(this.getPushDetailInfo.pushId)
      this.update_push_para.pushIdList = this.pushIdArray

      let obj = {context: this, para: this.update_push_para, successFun: (response) => {

      }}
      service.request(obj)
    },
    deletePushMsg: function () {
      if (this.getPushDetailInfo.pushType == 0) {
        this.delete_push_para.pushId = this.getPushDetailInfo.pushId

        let obj = {context: this, para: this.delete_push_para, successFun: (response) => {
          window.history.go(-1) // 返回
        }}
        service.request(obj)
      }
      if (this.getPushDetailInfo.pushType == 1) {
        this.delete_broadcast_para.pushIdList = this.getPushDetailInfo.pushId
        this.delete_broadcast_para.relationId = this.getPushDetailInfo.relationId
        this.delete_broadcast_para.userId = this.teacherId

        let obj = {context: this, para: this.delete_broadcast_para, successFun: (response) => {
          Toast('删除成功')
          window.history.go(-1) // 返回
        }}
        service.request(obj)
      }
    },
    getBroadCastMsg: function () {
      this.get_broadcast_list_para.curcheId = this.curcheId
      this.get_broadcast_list_para.userId = this.teacherId

      let that = this
      let obj = {context: this, para: this.get_broadcast_list_para, successFun: (response) => {
        that.getBroadcastInfo = response.data
        for (var i = 0; i < that.getBroadcastInfo.length; i++) {
          if (that.getBroadcastInfo[i].pushId == that.pushId) {
            that.detailInfo = that.getBroadcastInfo[i]
            that.detailInfo.relationId
            that.inviteId = this.detailInfo.inviteId
            if (that.detailInfo.field1 == 0) {
              that.updateBroadcasthMsg()
            }
          }
        }
      }}
      service.request(obj)
    },
    updateBroadcasthMsg: function () {
      // this.broadCastArray.push(this.detailInfo.pushId)
      this.update_broadcast_para.pushIdList = this.detailInfo.pushId
      this.update_broadcast_para.userId = this.teacherId
      this.update_broadcast_para.relationId = this.detailInfo.relationId

      let obj = {context: this, para: this.update_broadcast_para, successFun: (response) => {

      }}
      service.request(obj)
    },
    agreeTeacherAddCurcheMsg: function () {
      this.agree_Teacher_Add_Curche_para.inviteId = this.getPushDetailInfo.inviteId

      let that = this
      let obj = {context: this, para: this.agree_Teacher_Add_Curche_para, successFun: (response) => {
        that.getPushDetailInfo.isAgree = 1
        that.teacherId = response.data
      }}
      service.request(obj)
    },
    showDeleteAlert: function () {
      this.showAlert = false
    },
    hideDeleteAlert: function () {
      this.showAlert = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// NewsDetail.vue?78d12901